export const SET_COMPANIES = (state, company) => {
  state.companies = company;
};


